var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdhoc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.25 60.6367H60.25V0.636719H0.25V60.6367Z",
    fill: "white",
    fillOpacity: 0.01
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.0206 19.7113L53.9191 3.47552C52.9887 2.24866 51.537 1.52866 49.9967 1.53224H6.02658C4.44688 1.53224 2.96389 2.29164 2.0415 3.57403L25.0206 19.6934C26.8134 20.9731 29.2197 20.9803 31.0206 19.7113Z",
    fill: "url(#paint0_linear_901_3343)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.0206 19.7113L53.9191 3.47552C52.9887 2.24866 51.537 1.52866 49.9967 1.53224H6.02658C4.44688 1.53224 2.96389 2.29164 2.0415 3.57403L25.0206 19.6934C26.8134 20.9731 29.2197 20.9803 31.0206 19.7113Z",
    stroke: "url(#paint1_linear_901_3343)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.4117 37.353H49.9878C51.2693 37.37 52.5051 36.8757 53.4221 35.9801C54.34 35.0855 54.863 33.8613 54.8773 32.5798V6.30521C54.8782 5.27983 54.5415 4.28222 53.9191 3.4664L31.0206 19.7112C29.2215 20.99 26.8108 20.99 25.0117 19.7112L2.04152 3.57386C1.46391 4.3673 1.15047 5.32371 1.146 6.30521V32.5798C1.16032 33.8604 1.68241 35.0819 2.59764 35.9774C3.51286 36.8721 4.746 37.3673 6.02659 37.353H42.4117Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.4117 37.353H49.9878C51.2693 37.37 52.5051 36.8757 53.4221 35.9801C54.34 35.0855 54.863 33.8613 54.8773 32.5798V6.30521C54.8782 5.27983 54.5415 4.28222 53.9191 3.4664L31.0206 19.7112C29.2215 20.99 26.8108 20.99 25.0117 19.7112L2.04152 3.57386C1.46391 4.3673 1.15047 5.32371 1.146 6.30521V32.5798C1.16032 33.8604 1.68241 35.0819 2.59764 35.9774C3.51286 36.8721 4.746 37.3673 6.02659 37.353H42.4117Z",
    stroke: "url(#paint2_linear_901_3343)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.2351 59.741C52.1375 59.741 59.3545 52.524 59.3545 43.6216C59.3545 34.7192 52.1375 27.5022 43.2351 27.5022C34.3327 27.5022 27.1157 34.7192 27.1157 43.6216C27.1157 52.524 34.3327 59.741 43.2351 59.741Z",
    fill: "url(#paint3_linear_901_3343)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.2351 59.741C52.1375 59.741 59.3545 52.524 59.3545 43.6216C59.3545 34.7192 52.1375 27.5022 43.2351 27.5022C34.3327 27.5022 27.1157 34.7192 27.1157 43.6216C27.1157 52.524 34.3327 59.741 43.2351 59.741Z",
    stroke: "url(#paint4_linear_901_3343)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2349 36.4576V50.786",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0708 43.6218H50.3992",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_901_3343",
    x1: 27.9803,
    y1: 1.53223,
    x2: 27.9803,
    y2: 20.6582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#084277"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1E6E90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_901_3343",
    x1: 27.9803,
    y1: 1.53223,
    x2: 27.9803,
    y2: 20.6582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#084277"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1E6E90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_901_3343",
    x1: 28.0117,
    y1: 3.4664,
    x2: 28.0117,
    y2: 37.3534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#084277"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1E6E90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_901_3343",
    x1: 43.2351,
    y1: 27.5022,
    x2: 43.2351,
    y2: 59.741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#084277"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1E6E90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_901_3343",
    x1: 43.2351,
    y1: 27.5022,
    x2: 43.2351,
    y2: 59.741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#084277"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1E6E90"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdhoc);
export default __webpack_public_path__ + "static/media/ADHOC.575d49014be483f94844b39984e249cb.svg";
export { ForwardRef as ReactComponent };